<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<form [formGroup]="tournamentForm" (ngSubmit)="createTournament()">
    <mat-card>
        <mat-card-header>
            <mat-card-title>Create Tournament</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput type="text" required formControlName="name" name="name"/>
                @if (tournamentForm.controls.name.invalid && tournamentForm.controls.name.errors?.['required']) {
                    <mat-error>Name is required.</mat-error>
                }
                @if (tournamentForm.controls.name.invalid && tournamentForm.controls.name.errors?.['pattern']) {
                    <mat-error> Name contains characters that aren't allowed.</mat-error>
                }
                @if (tournamentForm.controls.name.invalid && tournamentForm.controls.name.errors?.['minlength']) {
                    <mat-error> Name needs to be at least one character long.</mat-error>
                }
                @if (tournamentForm.controls.name.invalid && tournamentForm.controls.name.errors?.['maxlength']) {
                    <mat-error> Name can't be more thant 200 characters.</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Registration end date</mat-label>
                <input
                        matInput
                        required
                        [matDatepicker]="picker"
                        formControlName="registrationEndDate"
                        name="registrationEndDate"
                        [min]="today"
                        #registrationEndDate
                />
                @if (tournamentForm.controls.registrationEndDate.invalid &&
                tournamentForm.controls.registrationEndDate.errors?.['required'] &&
                registrationEndDate.value.length === 0) {
                    <mat-error> Registration end is required</mat-error>
                } @else if (tournamentForm.controls.registrationEndDate.invalid &&
                tournamentForm.controls.registrationEndDate.errors?.['required'] &&
                !isValidDateString(registrationEndDate.value)) {
                    <mat-error> Registration end needs to be in format [DD.MM.YYYY]</mat-error>
                } @else if (tournamentForm.controls.registrationEndDate.invalid &&
                tournamentForm.controls.registrationEndDate.errors?.['matDatepickerMin']) {
                    <mat-error> Registration end needs to be in the future.</mat-error>
                }
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker [startAt]="today" #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Registration end time</mat-label>
                <input
                        matInput
                        type="time"
                        name="registrationEndTime"
                        formControlName="registrationEndTime"
                        required
                />
                @if (tournamentForm.controls.registrationEndTime.invalid &&
                tournamentForm.controls.maxParticipants.errors?.['required']) {
                    <mat-error> Registration end time is required.</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Maximum Participants</mat-label>
                <input
                        matInput
                        formControlName="maxParticipants"
                        required
                        type="number"
                        min="16"
                        step="1"
                        name="maxParticipants"
                />
                @if (tournamentForm.controls.maxParticipants.invalid &&
                tournamentForm.controls.maxParticipants.errors?.['required']) {
                    <mat-error> Max participants is required.</mat-error>
                }
                @if (tournamentForm.controls.maxParticipants.invalid &&
                tournamentForm.controls.maxParticipants.errors?.['min']) {
                    <mat-error> At least 16 participants are required.</mat-error>
                }
            </mat-form-field>

            <mat-checkbox class="waiting-list-checkbox" [formControlName]="'waitingListEnabled'">Activate registration
                list
            </mat-checkbox>


            <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <textarea formControlName="description" matInput name="description"></textarea>
            </mat-form-field>
        </mat-card-content>
        <mat-card-actions>
            <a
                    [disabled]="this.tournamentForm.disabled"
                    mat-button
                    [routerLink]="'..'"
                    color="warn"
                    style="margin-right: var(--spacing2)"
            >
                Cancel
            </a>

            <button
                    mat-flat-button
                    color="primary"
                    type="submit"
                    [disabled]="this.tournamentForm.disabled"
                    id="create-tournament"
            >
                Create
            </button>
        </mat-card-actions>
    </mat-card>
</form>
